import React, { useEffect, useState } from 'react';
import { getCertificatesForShipment } from '../lib/api';
import { useI18n } from '../contexts/I18nContext';
import { formatDate } from '../lib/utils';
import { FileText, AlertTriangle, CheckCircle, ExternalLink, Download } from 'lucide-react';
import { Badge } from './ui/badge';

export function ContractPanel({ mbl }) {
  const { t } = useI18n();
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!mbl) return;
    getCertificatesForShipment(mbl)
      .then(res => setContracts(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [mbl]);

  if (loading || contracts.length === 0) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-4" data-testid="contract-panel">
      <h3 className="text-sm font-medium mb-3 flex items-center gap-2">
        <FileText size={14} className="text-primary" />
        {t('certificates.contract')}
      </h3>
      <div className="space-y-2">
        {contracts.map(c => {
          const isExpired = c.status === 'expired';
          const isExpiring = c.status === 'expiring_soon';
          return (
            <div key={c.id} className="flex items-center justify-between p-2 rounded border border-border/50 bg-muted/10" data-testid={`contract-${c.id}`}>
              <div>
                <span className="text-sm font-medium">{c.product}</span>
                <div className="text-xs text-muted-foreground mt-0.5">
                  {t('certificates.expirationDate')}: {formatDate(c.expiration_date)}
                  {c.days_until_expiration !== null && (
                    <span className={isExpired ? 'text-red-400 ml-1' : isExpiring ? 'text-amber-400 ml-1' : 'text-green-400 ml-1'}>
                      ({c.days_until_expiration}d)
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-2">
                {isExpired && <Badge variant="destructive" className="text-xs gap-1"><AlertTriangle size={10} />{t('certificates.expired')}</Badge>}
                {isExpiring && <Badge variant="outline" className="text-xs gap-1 border-amber-500/30 text-amber-400"><AlertTriangle size={10} />{t('certificates.expiringSoon')}</Badge>}
                {!isExpired && !isExpiring && <Badge variant="outline" className="text-xs gap-1 border-green-500/30 text-green-400"><CheckCircle size={10} />{t('certificates.valid')}</Badge>}
                {c.file_url && (
                  <a href={c.file_url} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs bg-primary/10 text-primary hover:bg-primary/20 transition-colors"
                    data-testid={`contract-download-${c.id}`}
                  >
                    <Download size={11} />
                    Descargar
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
